// Consentimento de cookies (LGPD) — carrega GA4 e Clarity somente após aceite.
const KEY = "mat_cookie_consent";
const GA4_ID = "G-SYE3GLCXDC";
const CLARITY_ID = "xifauo30k3";

let _loaded = false;

export function getConsent() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function setConsent(value) {
  try { localStorage.setItem(KEY, value); } catch { /* ignore */ }
}

export function loadAnalytics() {
  if (_loaded || typeof window === "undefined") return;
  _loaded = true;

  // Google Analytics 4
  const ga = document.createElement("script");
  ga.async = true;
  ga.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(ga);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID);

  // Microsoft Clarity
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);
}

export const openCookiePreferences = () => window.dispatchEvent(new Event("mat:cookie-preferences"));
